import { forEach } from '../../utils/array-utils';
import { hideElement, unHideElement } from '../../utils/dom-utils';
import { safeUpperCase } from '../../utils/string-utils';

const setActiveInitial = (clickedElement, clickedInitial) => {
  const allInitialsElements = document.querySelectorAll('.j-letters .c-letters__letter');
  const currentLetterContainer = document.querySelector('.j-alphabetical-list .c-alphabetical-list__letter');

  forEach((initialElement) => {
    if (initialElement.classList.contains('is-active')) {
      initialElement.classList.remove('is-active');
    }
  })(allInitialsElements);

  clickedElement.closest('.c-letters__letter').classList.add('is-active');
  currentLetterContainer.innerText = clickedInitial;
};

const showCurrentInitialNames = (initial) => {
  const initialItem = initial.target;
  const initialLetter = initialItem.innerText.trim();
  const allNames = document.querySelectorAll('.j-alphabetical-list .c-alphabetical-list__name');

  setActiveInitial(initialItem, initialLetter);

  forEach((name) => {
    const nameInitial = safeUpperCase(name.firstElementChild.innerText.trim().charAt(0));

    if (initialLetter === nameInitial) {
      unHideElement(name);
      name.classList.add('is-active');
    } else {
      hideElement(name);
    }
  })(allNames);
};

const setClickableInitials = () => {
  const allInitials = document.querySelectorAll('.j-letters .c-letters__letter');

  forEach((initial) => {
    initial.addEventListener('click', (e) => {
      showCurrentInitialNames(e);
    });
  })(allInitials);
};

export const init = () => {
  const allNamesContainer = document.querySelector('.j-alphabetical-list .c-alphabetical-list__list');
  const allNames = allNamesContainer.querySelectorAll('.j-alphabetical-list .c-alphabetical-list__name');

  setClickableInitials();

  if (allNamesContainer) {
    const defaultInitial = allNamesContainer.dataset.initial || 'A';

    forEach((name) => {
      const nameInitial = safeUpperCase(name.firstElementChild.innerText.trim().charAt(0));

      if (nameInitial === defaultInitial) {
        unHideElement(name);
      }
    })(allNames);
  }
};
